
import { OrganizationStoreRepository } from "@domain/organization-store/repositories/organization-store.repository";
import { OrganizationStoreRepositoryService } from "../repositories/organization-store.service";

export const OrganizationStoreProvider = [
  {
    provide: OrganizationStoreRepository,
    useClass: OrganizationStoreRepositoryService,
  },
];